import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import React, { FC } from 'react'
import ResponsiveModal from '../ResponsiveModal'
import { FormattedMessage } from 'react-intl'
import CountryRegionSelection from '../CountryRegionSelection'

const useStyles = makeStyles()((theme) => ({
  modalBody: {
    padding: theme.spacing(6, 4),
  },
}))

interface Props {
  isOpen: boolean
  onClose: React.Dispatch<React.SetStateAction<boolean>>
}

const MobileRegionAndCountrySelectModal: FC<Props> = ({ isOpen, onClose }) => {
  const { classes } = useStyles()
  const onCloseModal = () => {
    onClose(false)
  }

  return (
    <ResponsiveModal
      disableEnforceFocus
      open={isOpen}
      onClose={onCloseModal}
      renderTitle={() => (
        <Typography variant="h2" component="h2">
          <FormattedMessage
            id="CHANGE_LOCATION"
            defaultMessage="Change Location"
          />
        </Typography>
      )}
    >
      <div className={classes.modalBody}>
        <CountryRegionSelection mobileDisplay />
      </div>
    </ResponsiveModal>
  )
}

export default MobileRegionAndCountrySelectModal
